<script setup>

const { locale } = useI18n()

const props = defineProps({
  concert: {
    type: Object,
  }
})

const getDate = (startdate) => {
	const date = new Date(startdate)
	const month = date.toLocaleString(locale.value, { month: 'short' });

	return `${month.toUpperCase()} ${date.getDate()}`
}

const getTime = (startdate) => {
	const date = new Date(startdate)

	return `${date.getHours()}:${date.getMinutes() < 10 ? '0' : ''}${date.getMinutes()}`
}

</script>

<template>
	<a :href="concert.attrs.url" target="_blank" class="block pb-8 my-8 border-b dark:border-light dark:border-opacity-30">
		<div class="sm:grid grid-cols-8 gap-8">
			<div class="col-span-2">
				<h4 class="dark:text-light mb-2 xl:mb-3 whitespace-nowrap">
					{{ getDate(concert.attrs.startdate) }}
				</h4>
				<h5 class="dark:text-light whitespace-nowrap mb-2 sm:mb-0">
					{{ getTime(concert.attrs.startdate) }}
				</h5>
			</div>
			<div :class="[concert.attrs.tickets?.items?.length ? 'col-span-4' : 'col-span-6']">
				<h4 class="dark:text-light mb-2 xl:mb-3">
					{{ concert.attrs.title }}
				</h4>
				<h5 class="dark:text-light">
					{{ concert.attrs.place?.attrs.city }} - {{ concert.attrs.place?.attrs.title }}
				</h5>
			</div>
			<div v-if="concert.attrs.tickets?.items?.length" class="col-span-2 sm:text-right">
				<Button :to="concert.attrs.tickets?.items[0].url" target class="mt-7">{{ $t('generic.tickets') }}</Button>
			</div>
		</div>
	</a>
</template>